"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.EspConnectionStatus = (_a) => {
    var { esp, esp: { integrationType } } = _a, props = tslib_1.__rest(_a, ["esp", "esp"]);
    let canConnect = false;
    let partialConnection = false;
    switch (integrationType) {
        case 'ActiveCampaign':
            esp = esp;
            canConnect = esp.canConnect;
            break;
        case 'Mailjet':
            esp = esp;
            canConnect = esp.canConnect;
            break;
        case 'CampaignMonitor':
            esp = esp;
            canConnect = esp.canConnect;
            break;
        case 'Sailthru':
            esp = esp;
            canConnect = esp.canConnect;
            break;
        case 'Salesforce':
            esp = esp;
            canConnect = esp.canConnectToREST && esp.canConnectToSOAP;
            partialConnection = esp.canConnectToREST !== esp.canConnectToSOAP;
            break;
        case 'Mailchimp':
            esp = esp;
            canConnect = esp.canConnect;
            break;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.ConnectionStatus, Object.assign({ canConnect: partialConnection ? 'partial' : canConnect }, props))));
};
exports.ConnectionStatus = props => {
    const { canConnect, fontSize, connectedText, disconnectedText, large, partiallyConnectedText, small, marginLeft, noText, } = props;
    const contents = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCircle, className: classnames_1.default('mr-1 py-3px', {
                'ml-2': marginLeft,
                'mr-2': large,
                'text-danger': canConnect === false,
                'text-success': canConnect === true,
                'text-warning': canConnect === 'partial',
            }) }),
        noText
            ? ''
            : canConnect === 'partial'
                ? partiallyConnectedText || 'Partially connected'
                : canConnect
                    ? connectedText || 'Connected'
                    : disconnectedText || 'Not connected'));
    if (large) {
        return react_1.default.createElement("p", { className: "lead mb-0" }, contents);
    }
    if (small) {
        return (react_1.default.createElement("small", { className: "ml-2", style: { fontSize } }, contents));
    }
    return contents;
};
//# sourceMappingURL=ConnectionStatus.js.map